<template>
  <b-card>
    <servico-list
      ref="servicoList"
      :carregar="carregar"
      :novo="novo"
      :editar="editar"
      :remover="remover"
      :colunas="colunasListagem"
      :info="info"
      :filtros="filtros"
      filtrar-por-ativo
      @removerItem="remover($event)"
    >
      <template slot="botoes-adicionais">
        <b-button
          variant="success btn-sm"
          class="mx-1"
          @click="exportar"
        >
          Exportar
        </b-button>
        <filtro-adicional
          v-if="carregado"
          :value="valueFiltro"
          @aplicar="maisFiltros($event)"
        />
      </template>
      <template
        slot="celula-personalizada"
        slot-scope="{ props }"
      >
        <!-- Coluna Rodízio -->
        <span v-if="props.column.label === 'Rodízio'">
          {{ props.row.participaRodizioEquipe ? 'Sim' : 'Não' }}
        </span>

        <!-- Coluna Valor Total com edição rápida -->
        <div
          v-else-if="props.column.label === 'Valor Total'"
          class="d-flex align-items-center justify-content-between"
        >
          <!-- MODO EDIÇÃO -->
          <template v-if="editandoValorId === props.row.id">
            <b-form-input
              v-model="valorEdicao"
              type="number"
              step="0.01"
              size="sm"
              class="text-right"
              :disabled="salvandoValor"
            />
            <b-button
              variant="success"
              size="sm"
              class="ml-1"
              :disabled="salvandoValor"
              @click.stop="salvarEdicaoRapida(props.row)"
            >
              <feather-icon icon="CheckIcon" />
            </b-button>
            <b-button
              variant="outline-secondary"
              size="sm"
              class="ml-1"
              :disabled="salvandoValor"
              @click.stop="cancelarEdicaoRapida"
            >
              <feather-icon icon="XIcon" />
            </b-button>
          </template>

          <!-- MODO VISUALIZAÇÃO -->
          <template v-else>
            <span>
              {{ formatarValor(props.row.valorAuditar) }}
            </span>
            <b-button
              variant="outline-primary"
              size="sm"
              class="ml-1"
              @click.stop="iniciarEdicaoRapida(props.row)"
            >
              <feather-icon icon="Edit3Icon" />
            </b-button>
          </template>
        </div>
      </template>
    </servico-list>
  </b-card>
</template>

<style lang="scss">
</style>

<script>
import api from '@/app-modulo/comuns/servico/shared/services/api'

export default {
  name: 'ServicoVisualizacao',
  components: {
    ServicoList: () => import('@/shared/components/visualizacao-base/VisualizacaoBase.vue'),
    FiltroAdicional: () => import('@/app-modulo/comuns/servico/shared/components/filtro-adicional/FiltroAdicional.vue'),
  },
  data() {
    return {
      colunasListagem: [
        {
          label: 'Nome', field: 'nome', type: 'personalizada', showActive: true, editable: true,
        },
        { label: 'Departamento', field: 'departamentoNome' },
        {
          label: 'Valor Total', field: 'valorAuditar', type: 'personalizada',
        },
        { label: 'Periodicidade', field: 'periodicidade' },
        { label: 'Rodízio', field: 'participaRodizioEquipe', type: 'personalizada' },
      ],
      filtros: [{ colunas: ['Nome', 'Rodizio', 'DepartamentoNome', 'Periodicidade'], valor: null }],
      info: [
        { label: 'Data de cadastro: ', campo: 'dataCadastro' },
        { label: 'Cadastrado por: ', campo: 'usuCadastro' },
        { label: 'Data de alteração: ', campo: 'dataAlteracao' },
        { label: 'Alterado por: ', campo: 'usuAlteracao' },
      ],
      valueFiltro: {
        tributacoes: null,
        atividades: null,
        buscaVinculoOmie: [],
        matriz: null,
      },
      carregado: false,

      // CONTROLE EDIÇÃO RÁPIDA DO VALOR
      editandoValorId: null,
      valorEdicao: '',
      salvandoValor: false,
    }
  },
  methods: {
    formatarValor(value) {
      if (value === null || value === undefined || value === '') return ''
      const num = Number(value)
      if (Number.isNaN(num)) return value
      const fixed = Number(num.toFixed(2))
      return fixed.toLocaleString('pt-BR', {
        currency: 'BRL',
        style: 'currency',
        minimumFractionDigits: 2,
      })
    },

    // ==== EDIÇÃO RÁPIDA DO VALOR TOTAL ====
    iniciarEdicaoRapida(row) {
      this.editandoValorId = row.id
      this.valorEdicao = row.valorAuditar
    },

    cancelarEdicaoRapida() {
      this.editandoValorId = null
      this.valorEdicao = ''
      this.salvandoValor = false
    },

    async salvarEdicaoRapida(row) {
      try {
        const valorNumero = parseFloat(this.valorEdicao)

        if (Number.isNaN(valorNumero)) {
          this.$swal({
            text: 'Informe um valor numérico válido.',
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: 'OK',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
          })
          return
        }

        this.salvandoValor = true

        // Carrega o serviço completo
        const { data: servico } = await api.getServico(row.id)

        // Ajusta também o objeto de reajuste (se existir), para seguir a mesma regra da tela de edição
        const reajusteAtual = servico.reajuste || {}
        const reajusteAtualizado = {
          ...reajusteAtual,
          valorAuditar: valorNumero,
        }

        // Monta o payload semelhante ao cadastro/edição
        const payload = {
          ...servico,
          valorAuditar: valorNumero,
          reajuste: reajusteAtualizado,
          DepartamentoGClickId: servico.departamentoGClick ? parseInt(servico.departamentoGClick.id, 10) : null,
          ProcessoGClickId: servico.processoGClick ? parseInt(servico.processoGClick.id, 10) : null,
          FluxoGClickId: servico.fluxoGClick ? parseInt(servico.fluxoGClick.id, 10) : null,
        }

        await api.updateServico(row.id, payload)

        // Atualiza o valor na linha atual (sem violar no-param-reassign)
        const linhaEditada = row
        linhaEditada.valorAuditar = valorNumero

        this.cancelarEdicaoRapida()
      } catch (error) {
        this.salvandoValor = false
        this.$swal({
          text: 'Erro ao atualizar o valor do serviço.',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'OK',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
        })
      }
    },

    // ==== FILTROS / CARGA ====
    maisFiltros(filtros) {
      this.valueFiltro = filtros
      this.$refs.servicoList.montarGrid()
    },
    carregar(page, pageSize, filtro) {
      this.carregado = true
      const filtros = {
        filtroPricipal: filtro,
        filtrosAdicionais: this.valueFiltro,
      }
      return api.getServicos(page, pageSize, filtros)
    },

    // ==== AÇÕES PADRÃO ====
    novo() {
      this.$router.push({ name: 'novo-servico' })
    },
    editar(value) {
      this.$router.push({ name: 'editar-servico', params: { id: value.id } })
    },
    remover(itens) {
      if (itens && itens.length === 1) {
        return new Promise((resolve, reject) => {
          api.verificaVinculo(itens[0].id)
            .then(payload => {
              if (payload.data) {
                this.$swal({
                  text: 'Não é permitido realizar essa exclusão, pois este registro está associado em campos obrigatórios de outros cadastros.',
                  icon: 'warning',
                  showCancelButton: false,
                  confirmButtonText: 'OK',
                  customClass: {
                    confirmButton: 'btn btn-primary',
                  },
                })
                  .then(() => {
                    reject()
                  })
                  .catch(err => {
                    reject(err)
                  })
              } else {
                api.deleteServico(itens[0].id)
                  .then(() => {
                    resolve(false)
                  })
                  .catch(err => {
                    reject(err)
                  })
              }
            })
            .catch(err => {
              reject(err)
            })
        })
      }

      const idList = itens.map(map => map.id)
      return api.deleteAll({ identificadores: idList })
    },
    async exportar() {
      try {
        const response = await api.exportarServicos()
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'servicos.xlsx'
        document.body.appendChild(a)
        a.click()
        a.remove()
        window.URL.revokeObjectURL(url)
      } catch (error) {
        this.$swal({
          text: 'Erro ao exportar os dados.',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'OK',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
        })
      }
    },
  },
}
</script>
